import { render, staticRenderFns } from "./EditSocietySection.vue?vue&type=template&id=330816f5"
import script from "./EditSocietySection.vue?vue&type=script&lang=js"
export * from "./EditSocietySection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports